import useSWR from 'swr'
import queryString from 'query-string'
import moment from 'moment'
import { formatDate } from '../../../../../utils/formatters'

export const useSchedulingDetails = (professionalId, date, detailed = false, revalidateOnFocus = false) => {
  const query = {
    start: formatDate({ date: moment(date).startOf('month'), format: 'DD-MM-YYYY' }),
    end: formatDate({ date, format: 'DD-MM-YYYY' })
  }
  const detailedRoute = detailed ? '/detailed' : ''
  const url = `${process.env.REACT_APP_SCHEDULER_URL}/report/professional/${professionalId}/count-by-status${detailedRoute}?${queryString.stringify(query,
    { arrayFormat: 'bracket' })}`

  const { data } = useSWR(url, { revalidateOnFocus })

  return data
}
